import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "@/components/Landing";
import IdeaFusion from "@/components/IdeaFusion";
import TechSpec from "@/components/TechSpec";

function App() {
  return (
    <div className="App">
      <div className="grain-overlay" />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/app" element={<IdeaFusion />} />
          <Route path="/tech-spec" element={<TechSpec />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
